
















































import { Component, Prop } from 'vue-property-decorator';
import VFormBuilder from '../../shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';
import DeliveryFeesForm from '@/components/venue/form/DeliveryFeesForm.vue';
import { DeliveryFee } from '@/interfaces/models/DeliveryFee';
import DeliveryPostalCode from '@/components/venue/form/DeliveryPostalCode.vue';
import DeliveryFeesPostalCodeForm from '@/components/venue/form/DeliveryFeesPostalCodeForm.vue';
import { DeliveryFeePostalCode } from '@/interfaces/models/DeliveryFeePostalCode';

@Component({
  components: { DeliveryFeesPostalCodeForm, DeliveryPostalCode, DeliveryFeesForm, VFormBuilder },
})
export default class PreorderForm extends mixins(StackedForm) {
  @Prop({ type: Boolean, default: true }) public offsets!: boolean;
  @Prop({ type: Boolean, default: true }) public fees!: boolean;
  @Prop({ type: Boolean, default: false }) public disablePreorderDelivery!: boolean;
  @Prop({ type: Boolean, default: false }) public disablePreorderTakeAway!: boolean;
  @Prop({ type: Boolean, default: false }) public disablePreorderParkCollect!: boolean;
  @Prop({ type: Boolean, default: false }) public disablePreorderInside!: boolean;
  @Prop({ type: Boolean, default: false }) public disableDeliveryPostalCode!: boolean;

  postalCodes: string[] = [];

  public $refs!: {
    preorderForm: InstanceType<typeof VFormBuilder> & { form: any };
    feeForm: InstanceType<typeof VFormBuilder> & { fees: DeliveryFee[] };
    feePostalCodeForm: InstanceType<typeof VFormBuilder> & { fees: DeliveryFeePostalCode[] };
    preorderOffsetForm: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get preorderItems() {
    return [
      { name: 'panicEndAt', type: InputType.DateTime, label: 'venue.form.panicEndAt' },
      {
        name: 'preorderTakeAway',
        type: InputType.Checkbox,
        label: 'venue.form.preorderTakeAway',
        default: false,
        visible: !this.disablePreorderTakeAway,
      },
      {
        name: 'preorderParkCollect',
        type: InputType.Checkbox,
        label: 'venue.form.preorderParkCollect',
        default: false,
        visible: !this.disablePreorderParkCollect,
      },
      {
        name: 'deliveryByRadius',
        type: InputType.Checkbox,
        label: 'venue.form.deliveryByRadius',
        default: true,
        visible: !this.disablePreorderDelivery,
      },
      { name: 'deliveryPostalCodes', type: InputType.Hidden, default: [] },
      {
        name: 'preorderIn',
        type: InputType.Checkbox,
        label: 'venue.form.preorderIn',
        default: false,
        visible: !this.disablePreorderInside,
      },
      {
        name: 'deliveryEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.preorderDelivery',
        default: false,
        visible: !this.disablePreorderDelivery,
      },
      {
        name: 'movDelivery',
        type: InputType.Text,
        label: 'venue.form.movDelivery',
        // @ts-ignore
        labelProp: { currency: this.initialValues ? this.initialValues.currency : 'EUR' },
        default: '0',
        visible: !this.disablePreorderDelivery,
      },
      {
        name: 'deliveryRadius',
        type: InputType.Slider,
        label: 'venue.form.deliveryRadius',
        min: 1,
        max: 20,
        default: 20,
        visible: this.activeDeliveryTypeCallback && !this.disablePreorderDelivery,
      },
    ];
  }

  public activeDeliveryTypeCallback(form: { deliveryByRadius?: boolean }) {
    return form.deliveryByRadius !== false;
  }

  get getPreorderOffsetItems() {
    return [{ name: 'autoDeclineTime', type: InputType.Text, label: 'venue.form.autoDeclineTime', default: 15 }];
  }

  public getData() {
    if (this.$refs.preorderOffsetForm && this.$refs.feeForm) {
      return {
        ...this.$refs.preorderForm.form,
        ...this.$refs.preorderOffsetForm.form,
        deliveryFees: this.$refs.feeForm ? this.$refs.feeForm.fees : [],
        deliveryFeesPostalCodes: this.$refs.feePostalCodeForm ? this.$refs.feePostalCodeForm.fees : null,
      };
    }
    return {
      ...this.$refs.preorderForm.form,
      deliveryFees: this.$refs.feeForm ? this.$refs.feeForm.fees : [],
      deliveryFeesPostalCodes: this.$refs.feePostalCodeForm ? this.$refs.feePostalCodeForm.fees : null,
    };
  }
}
